import { ConfirmNewContract } from './ConfirmNewContract';

export default ConfirmNewContract;
